import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize PostHog for Telemetry
posthog.init(process.env.REACT_APP_POSTHOG_KEY || 'missing_key', {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
  autocapture: false, // Explicit tracking only to avoid noise
});

// Initialize Sentry for production error monitoring
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "", // Replace with your actual DSN in Vercel
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, 
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0, 
});

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  const root = createRoot(container);
  root.render(app);
}
